import axios from 'axios'
import router from '../router'

// 请求超时时间
axios.defaults.timeout = 10000

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response)
    if (response.status === 200) {
      if (response.data.code == '300') {
        console.log(response.data);
        localStorage.removeItem('impr_id')
        localStorage.removeItem('impr_token')
        router.push({ path: '/login' })
        return Promise.resolve(response)
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log(error)
    if (error.response.status) {
      return Promise.reject(error.response)
    }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err.data)
    })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      if (err.statusText == 'Internal Server Error') {
        this.$confirm({
          title: '程序错误',
          content: '联系后端工程师进行处理',
          okText: 'OK',
        })
      }
      reject(err.data)
    })
  })
}

